<template>
    <div>
        <loading v-if="loading"></loading>
        <table v-else-if="view == 'calendar'" class="calendar">
            <thead>
                <tr>
                    <th>Sunday</th>
                    <th>Monday</th>
                    <th>Tuesday</th>
                    <th>Wednesday</th>
                    <th>Thursday</th>
                    <th>Friday</th>
                    <th>Saturday</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(week, i) in weeks" :key="i">
                    <td v-for="(day, j) in week" :key="j" :class="{ 'pad': !IsInMonthRange(i, j), 'today': IsToday(i, j) }">
                        <div class="calendar-day-of-month" v-if="IsInMonthRange(i, j)">
                            <span v-if="IsToday(i, j)"><b>{{ i * 7 + j - paddingNum[0] + 1 }}</b></span>
                            <span v-else>{{ i * 7 + j - paddingNum[0] + 1 }}</span>
                        </div>
                        <div class="calendar-appointment" v-for="(a, k) in day" :key="k" @click="OpenAppointment(a)">
                            <span v-if="!a?.IsAllDay">{{ moment(a?.Start).format('h:mma').replace(/pm/, 'p') }}</span> <b>{{ a?.Subject }}</b>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-else-if="view == 'list'" class="calendar" type="list">
            <div v-for="(day, i) in upcoming" :key="i">
                <div class="list-dow-title">
                    <span v-if="IsSameDay(day[0].Start)">Today</span>
                    <span v-else>{{ moment(day[0].Start).format('dddd, D MMMM') }}</span>
                </div>
                <div v-for="(a, j) in day" :key="j" class="list-appointment" @click="OpenAppointment(a)">
                    <span v-if="!a.IsAllDay">{{ moment(a.Start).format('h:mma') }}</span> <b>{{ a.Subject }}</b> <span v-if="StartingSoon(a.Start)" class="coming-up">(Starts soon)</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { ref, inject, computed, onMounted } from "vue";
    import calendarAppointmentModal from "@/components/modals/calendarAppointmentModal.vue";
    export default {
        props: {
            view: {
                type: String,
                default: "calendar"
            },
            limitMonths: {
                type: [String, Number],
                default: 6
            },
            limitEvents: {
                type: [String, Number],
                default: 10
            }
        },
        setup(props, context) {
            const http = inject("$http");
            const moment = inject("$moment");
            const oruga = inject("$oruga");

            const loading = ref(true);
            const calendar_days = ref([]);
            const weeks = ref([]);
            const upcoming = ref([]);
            const paddingNum = ref([0, 0]);

            const GetCalendar = async () => {
                try {
                    const qs = `?limitMonths=${props.limitMonths}&limitEvents=${props.limitEvents}`;
                    const response = await http.get("/api/v2/widget/calendar" + qs);
                    upcoming.value = response.data.upcoming;
                    calendar_days.value = response.data.calendar;
                    BreakdownCalendar(response.data.calendar);
                }
                catch (err) {
                    console.error(err);
                }
            }

            const BreakdownCalendar = (data) => {
                const padded_calendar = Pad(data);
                weeks.value = [];
                for (let i = 0; i < padded_calendar.length; i += 7) {
                    weeks.value = weeks.value.concat([padded_calendar.slice(i, i + 7)]);
                }
            }

            const Pad = (data) => {
                const d = moment();

                //pad beginning
                d.date(1);
                let dayOfWeek = d.day();
                let padding = [];
                for (let i = 0; i < dayOfWeek; i++) {
                    padding.push([]);
                }
                data = padding.concat(data);
                paddingNum.value[0] = padding.length;

                //pad ending
                d.date(data.length);
                dayOfWeek = d.day();
                padding = [];
                for (let i = 0; i < dayOfWeek - 1; i++) {
                    padding.push([]);
                }
                data = data.concat(padding);
                paddingNum.value[1] = padding.length;

                return data;
            }

            const daysInMonth = computed(() => {
                return calendar_days.value.length;
            });

            const IsInMonthRange = (weekOfMonth, dayOfWeek) => {
                return paddingNum.value[0] <= weekOfMonth * 7 + dayOfWeek && daysInMonth.value + paddingNum.value[0] > weekOfMonth * 7 + dayOfWeek;
            }

            const IsToday = (weekOfMonth, dayOfWeek) => {
                const dayOfMonth = moment().date();
                return dayOfMonth == weekOfMonth * 7 + dayOfWeek;
            }

            const IsSameDay = (d) => {
                return moment(d).isSame(moment(), 'day');
            }

            const StartingSoon = (d) => {
                const appt = moment(d);
                const currentDate = moment();
                const hourLater = moment().add(1, 'hour');
                return appt.isBetween(currentDate, hourLater);
            }

            const OpenAppointment = (appointment) => {
                oruga.modal.open({
                    parent: this,
                    component: calendarAppointmentModal,
                    trapFocus: true,
                    props: {
                        appointment: appointment
                    }
                });
            }


            onMounted(async () => {
                await GetCalendar();
                loading.value = false;
            })

            return {
                moment,
                loading,
                weeks,
                upcoming,
                paddingNum,
                daysInMonth,
                IsInMonthRange,
                IsToday,
                IsSameDay,
                StartingSoon,
                OpenAppointment
            }
        }
    }
</script>
<style lang="scss">
    table.calendar {
        width: 100%;
        font-family: "wf_segoe-ui_light", "Segoe UI Light", "Segoe WP Light", "Segoe UI", "Segoe WP", Tahoma, Arial, sans-serif;
        cursor: default;

        & tr {
            & th {
                background-color: #f7f7f7;
                padding-left: 2px;
            }

            & td {
                border: solid 1px black;
                min-width: 40px;
                max-width: 100px;
                height: 40px;

                &.pad {
                    background-color: lightgray;
                }

                &.today {
                    background-color: #f2f2f2;
                }

                & .calendar-day-of-month {
                    /*padding-left: 5px;*/
                    font-size: 12pt;
                }

                & .calendar-appointment {
                    /*margin-left: -5px;*/
                    padding: 0px 4px;
                    font-size: 12px;
                    white-space: nowrap;
                    overflow-x: hidden;
                    text-overflow: ellipsis;
                    background-color: #bceffc;
                    margin-top: 2px;
                    cursor: pointer;
                }

                & .b-tooltip {
                    width: 100%;
                }
            }
        }

        & .b-tooltip.is-primary .tooltip-content {
            background: #fefefe;
            color: inherit;
            font-size: 14px;

            /*&:hover {
                display:block !important;
            }*/

            & .tip-head {
                /*background: #BCE5FC;*/
                border-bottom: solid 1px lightgray;
                margin-bottom: 6px;
            }

            & .tip-body {}
        }

        & .b-tooltip.is-right.is-primary .tooltip-content::before {
            border-right-color: #efefef;
        }

        & .b-tooltip.is-left.is-primary .tooltip-content::before {
            border-left-color: #efefef;
        }
    }

    div.calendar[type="list"] {
        /*max-height: 500px;*/
        overflow-y: auto;

        & .list-appointment {
            background: #bce5fc;
            padding: 2px 6px;
            border-radius: 2px;
            font-size: 12pt;
            margin-bottom: 4px;
            cursor: pointer;

            &:first-child {
                font-size: 14pt;
            }
        }

        & .coming-up {
            color: red;
        }
    }
</style>
